import React from "react";
import { useState } from "react";
import Header from "../header";
import AddTicket from "./AddTicket";
import BasicTabs from "./Tabs";

const Vendor = (props) => {
  const [addTicket, setAddTicket] = useState(false);
  const vendorId = props.match.params.vendor_id;
  const categoryId = props.match.params.categoryId;
  const propsSearch = props.location.search;
  const ticketHandler = () => {
    setAddTicket(!addTicket);
  };
  return addTicket ? (
    <AddTicket ticketHandler={ticketHandler} vendorId={vendorId} />
  ) : (
    <div dir="rtl">
      <Header showSearchBar={true} title={"vendor"} />
      <BasicTabs
        vendorId={vendorId}
        categoryId={categoryId}
        propsSearch={propsSearch}
        ticketHandler={ticketHandler}
      />
    </div>
  );
};

export default Vendor;
